import React from "react";
import PropTypes from "prop-types";

import AddButton from "./AddButton";
import AccountGraph from "./AccountGraph";
import AccountGraphInverted from "./AccountGraphInverted";
import AppDropdown from "./AppDropdown";
import Archive from "./Archive";
import ArchiveMultiple from "./ArchiveMultiple";
import BlockList from "./BlockList";
import EditIcon from "./EditIcon";
import EngagementManager from "./EngagementManager";
import Channel from "./Channel";
import Chart from "./Chart";
import ChevronLeft from "./ChevronLeft";
import ClientApp from "./ClientApp";
import ContentRatings from "./ContentRatings";
import DiscoverContentRatings from "./DiscoverContentRatings";
import DownloadMultiple from "./DownloadMultiple";
import { DVLogo } from "./DVLogo";
import DVLogoPinnacle from "./DVLogoPinnacle";
import Exclusion from "./Exclusion";
import ExclusionBrandSafety from "./ExclusionBrandSafety";
import ExclusionCategorical from "./ExclusionCategorical";
import ExclusionGroup from "./ExclusionGroup";
import ExclusionManual from "./ExclusionManual";
import ExternalLink from "./ExternalLink";
import FileExtension from "./FileExtension";
import Filter from "./Filter";
import Gear from "./Gear";
import HighRiskFlag from "./HighRiskFlag";
import Info from "./Info";
import ModelBuilder from "./ModelBuilder";
import Monetization from "./Monetization";
import MonthlyViews from "./MonthlyViews";
import OpenSlateLogo from "./OpenSlateLogo";
import Page from "./Page";
import PodCorner from "./PodCorner";
import PodCornerExpanded from "./PodCornerExpanded";
import Reports from "./Reports";
import Ribbon from "./Ribbon";
import Search from "./Search";
import ServerClient from "./ServerClient";
import Storybook from "./Storybook";
import SupportLink from "./SupportLink";
import Target from "./Target";
import TargetingApp from "./TargetingApp";
import Tools from "./Tools";
import Unarchive from "./Unarchive";
import Views from "./Views";
import Videos from "./Videos";
import VideoCatalog from "./VideoCatalog";
import VideosTriangle from "./VideosTriangle";

const OSSIcon = props => {
  const icons = {
    addButton: AddButton,
    account_graph: AccountGraph,
    accountGraphInverted: AccountGraphInverted,
    appDropdown: AppDropdown,
    archive: Archive,
    archive_multiple: ArchiveMultiple,
    blocklist: BlockList,
    engagementManager: EngagementManager,
    channel: Channel,
    chart: Chart,
    chevronLeft: ChevronLeft,
    clientApp: ClientApp,
    contentRatings: ContentRatings,
    discoverContentRatings: DiscoverContentRatings,
    download_multiple: DownloadMultiple,
    dvLogo: DVLogo,
    dvLogoPinnacle: DVLogoPinnacle,
    edit: EditIcon,
    exclusion_brand_safety: ExclusionBrandSafety,
    exclusion_categorical: ExclusionCategorical,
    exclusionGroup: ExclusionGroup,
    exclusion_manual: ExclusionManual,
    exclusion: Exclusion,
    externalLink: ExternalLink,
    fileExtension: FileExtension,
    filter: Filter,
    gear: Gear,
    high_risk_flag: HighRiskFlag,
    info: Info,
    modelBuilder: ModelBuilder,
    monetization: Monetization,
    monthlyViews: MonthlyViews,
    openSlateLogo: OpenSlateLogo,
    page: Page,
    podCorner: PodCorner,
    podCornerExpanded: PodCornerExpanded,
    reports: Reports,
    ribbon: Ribbon,
    search: Search,
    serverClient: ServerClient,
    storybook: Storybook,
    supportLink: SupportLink,
    target: Target,
    targeting: TargetingApp,
    tools: Tools,
    user: ExclusionManual,
    unarchive: Unarchive,
    views: Views,
    videos: Videos,
    video_catalog: VideoCatalog,
    videosTriangle: VideosTriangle
  };

  if (!props.name) {
    return null;
  }

  const IconName = icons[props.name];
  return IconName ? <IconName {...props} /> : null;
};

OSSIcon.propTypes = {
  name: PropTypes.string.isRequired,
  variant: PropTypes.string,
  size: PropTypes.string
};

export default OSSIcon;
